const _VERSION = '1.39.3'

export const VERSION = isProd() ? _VERSION : ''

function isProd() {
    return process.env.NODE_ENV === 'production'
}
